import { Button } from '@components/Button';
import { Label } from '@components/styled/Label.styled';
import { useDidUpdateEffect } from '@hooks/useDidUpdateEffect';
import { CheckCircleIcon } from '@src/assets';
import React, { useEffect, useState } from 'react';
import * as styled from './styled/SubmitGroup.styled';

export const AddressVerifySubmitGroup: React.FC<{
    addressVerified?: boolean;
    disabled?: boolean;
    label: string;
    onSubmit: React.ReactEventHandler;
    variant?: 'contained' | 'outlined';
    isLoading?: boolean;
}> = ({ addressVerified, disabled, label, onSubmit, variant }) => {
    const [success, setSuccess] = useState(false);
    const [showInfo, setShowInfo] = useState(true);
    useEffect(() => {
        if (addressVerified) {
            setShowInfo(false);
            setSuccess(true);
            const timeout = setTimeout(() => {
                setSuccess(false);
            }, 5000);
            return () => clearTimeout(timeout);
        }
    }, [addressVerified]);

    useDidUpdateEffect(() => {
        if (!success) {
            const timeout = setTimeout(() => {
                setShowInfo(true);
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [success]);

    return (
        <styled.SubmitGroup>
            <Button disabled={disabled} onClick={onSubmit} variant={variant}>
                <Label>{label}</Label>
            </Button>
            {!showInfo && (
                <styled.SuccessCard visible={success}>
                    <CheckCircleIcon />
                    <span>
                        Address verified. Continue filling out the form to generate an estimate.
                    </span>
                </styled.SuccessCard>
            )}
        </styled.SubmitGroup>
    );
};
